import { render, staticRenderFns } from "./SelectOption.vue?vue&type=template&id=25a90ab4&scoped=true&lang=html"
import script from "./SelectOption.vue?vue&type=script&lang=js"
export * from "./SelectOption.vue?vue&type=script&lang=js"
import style0 from "./SelectOption.vue?vue&type=style&index=0&id=25a90ab4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a90ab4",
  null
  
)

export default component.exports